import { directusApi } from '@/api';
import { Data } from '@/models/data.model';
import { asyncForEach, formatNested, validateFileName } from '@/utils';
import lodash from 'lodash';
import { VueTreeList, Tree, TreeNode } from 'vue-tree-list';
export interface ProductCategory {
    id?: number;
    slug: string;
    name: string;
    image?: any;
    cover?: any;
    parent_id?: any;
}

export interface ProductCategoryState {
    allProductCategories: Array<ProductCategory>;
    nestedProductCategories: Array<ProductCategory>;
    allProductCategoriesLoading: boolean;

    activeProductCategory: ProductCategory | null;
    activeProductCategoryLoading: boolean;
}

const state: ProductCategoryState = {
    allProductCategories: [],
    nestedProductCategories: [],
    allProductCategoriesLoading: false,

    activeProductCategory: {
        id: 0,
        slug: '',
        name: '',
        image: [],
        cover: [],
        parent_id: 0
    },
    activeProductCategoryLoading: false,
};

const defaultProductCategory = {
    id: 0,
    slug: '',
    name: '',
    image: null,
    cover: null,
    parent_id: 0
};

const mutations = {
    TOGGLE_ALL_CATEGORIES_LOADING(state: ProductCategoryState, data: boolean) {
        state.allProductCategoriesLoading = data;
    },
    SET_ALL_CATEGORIES(state: ProductCategoryState, data: Array<ProductCategory>) {
        state.allProductCategories = data;
        state.nestedProductCategories = new Tree(
            formatNested(
                data.map(item => {
                    return {
                        ...item,
                        dragDisabled: true,
                        addTreeNodeDisabled: true,
                        addLeafNodeDisabled: true,
                        editNodeDisabled: false,
                        delNodeDisabled: false,
                    };
                }),
                'id',
                'parent_id'
            )
        );
    },
    TOGGLE_ACTIVE_PRODUCT_CATEGORY_LOADING(state: ProductCategoryState, data: boolean) {
        state.activeProductCategoryLoading = data;
    },
    REMOVE_PRODUCT_CATEGORY(state: ProductCategoryState, id: number) {
        state.allProductCategories = lodash.remove(state.allProductCategories, function (n) {
            return n.id != id;
        });
    },
    async SET_ACTIVE_PRODUCT_CATEGORY(state: ProductCategoryState, data: ProductCategory) {
        let cover = null;
        if (data.cover) {
            await directusApi('GET', `files/${data.cover}`)
                .then(async (resFile: any) => {
                    cover = { id: data.cover, url: `https://directus.prodelec.app/assets/${data.cover}`, origin: 'directus', alt: resFile.data.data.alt };
                })
                .catch(err => {
                    console.log(err);
                });
        } else {
            cover = null;
        }

        let image = data.image ? { id: data.image, url: `https://directus.prodelec.app/assets/${data.image}`, origin: 'directus' } : null;
        // let cover = data.cover ? { id: data.cover, url: `https://directus.prodelec.app/assets/${data.cover}`, origin: 'directus' } : null;

        state.activeProductCategory = {
            ...data,
            image,
            cover
        };
    },
};

const actions = {
    async getAll({ _, commit }: any, data: Data | null) {
        let params = '';
        if (data) params += `&search=${data.search}`;
        params += '&limit=-1&meta=total_count&sort=name';
        commit('TOGGLE_ALL_CATEGORIES_LOADING', true);
        await directusApi('GET', `items/products_categories?${params}`) //change to dinamnic limit
            .then(res => {
                commit('SET_ALL_CATEGORIES', res.data.data);
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_ALL_CATEGORIES_LOADING', false);
            });
    },
    async getOne({ _, commit }: any, id: any | null = null) {
        commit('TOGGLE_ACTIVE_PRODUCT_CATEGORY_LOADING', true);
        if (id) {
            await directusApi('GET', `items/products_categories/${id}`)
                .then(res => {
                    commit('SET_ACTIVE_PRODUCT_CATEGORY', res.data.data);
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => {
                    commit('TOGGLE_ACTIVE_PRODUCT_CATEGORY_LOADING', false);
                });
        } else {
            commit('SET_ACTIVE_PRODUCT_CATEGORY', defaultProductCategory);
            commit('TOGGLE_ACTIVE_PRODUCT_CATEGORY_LOADING', false);
        }
    },
    async postOne({ _, commit, dispatch }: any, data: any) {
        commit('TOGGLE_ACTIVE_PRODUCT_CATEGORY_LOADING', true);

        let categoryEndpoint: string = 'items/products_categories';
        let categoryMethod: any = 'POST';

        if (data.data.id != 0) {
            categoryMethod = 'PATCH';
            categoryEndpoint = `items/products_categories/${data.data.id}`;
        }

        await directusApi(categoryMethod, categoryEndpoint, {
            name: data.data.name,
            slug: data.data.slug,
            parent_id: data.parent_id
        })
            .then(async (category: any) => {

                let image: any = {};
                data.data.image == '' ? (image = null) : (image = category.data.data.image);

                let cover: any = {};
                data.data.cover == '' ? cover = null : cover = category.data.data.cover;

                let complete_image = data.data.complete_image;

                try {
                    if (data.data.image.origin == 'upload') {
                        let imageNameValidation = await validateFileName(data.data.image.name);
                        if (imageNameValidation == 0) {
                            console.log('uploading', data.data.image);
                            await directusApi('POST', `files`, data.data.image.file)
                                .then(async (resFile: any) => {
                                    // image = { id: resFile.data.data.id };
                                    image = [
                                        {
                                            id: resFile.data.data.id,
                                            sort: data.data.image.sort,
                                            url: `https://directus.prodelec.app/assets/${resFile.data.data.id}`,
                                            origin: 'directus',
                                            name: resFile.data.data.title,
                                            file: data.data.image.file
                                        }
                                    ];
                                    await asyncForEach(complete_image, async (complete_gallery_item, complete_gallery_index) => {
                                        console.log('posting rezising file image :D');
                                        if (complete_gallery_item.origin != 'directus') {
                                            await directusApi('POST', `files`, complete_gallery_item.file)
                                                .then(async (resFile: any) => {
                                                    if (data.data.image.hasOwnProperty('alt')) {
                                                        await directusApi('PATCH', `files/${resFile.data.data.id}`, { alt: data.data.image.alt })
                                                            .then(async (resFile: any) => {
                                                                console.log('Alt added to complete gallery');
                                                            })
                                                            .catch(err => {
                                                                console.log(err);
                                                            });
                                                    }
                                                    complete_image[complete_gallery_index] = { id: resFile.data.data.id, sort: null, name: resFile.data.data.title, origin: 'directus', alt: data.data.image.hasOwnProperty('alt') ? data.data.image.alt : '' };
                                                })
                                                .catch(err => {
                                                    console.log(err);
                                                });
                                        }
                                    });
                                })
                                .catch(err => {
                                    console.log(err);
                                });
                        } else {
                            data.vm.$bvToast.toast(`Error al guardar, la imagen ${data.data.image.name} ya existe.`, {
                                title: `Imagen ya existente`,
                                variant: 'warning',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                            commit('TOGGLE_ACTIVE_PRODUCT_CATEGORY_LOADING', false);
                            return false;
                        }
                    } else if (data.data.image.origin == 'directus-update') {
                        image = { id: data.data.image.id };
                        await directusApi('GET', `files/${data.data.image.id}`)
                            .then(async (resFile: any) => {
                                image = resFile.data.data;
                            })
                            .catch(err => {
                                console.log(err);
                            });
                    } else {
                        if (data.data.image) {
                            await directusApi('GET', `files/${data.data.image.id}`)
                                .then(async (resFile: any) => {
                                    image = resFile.data.data;
                                })
                                .catch(err => {
                                    console.log(err);
                                });
                        }
                    }
                } catch (error) {
                    console.log('error => no contiene una imagen');
                }

                let complete_cover = data.data.complete_cover;

                try {
                    if (data.data.cover.origin == 'upload') {
                        let coverNameValidation = await validateFileName(data.data.cover.name);
                        if (coverNameValidation == 0) {
                            await directusApi('POST', `files`, data.data.cover.file)
                                .then(async (resFile: any) => {
                                    cover = [
                                        {
                                            id: resFile.data.data.id,
                                            sort: data.data.cover.sort,
                                            url: `https://directus.prodelec.app/assets/${resFile.data.data.id}`,
                                            origin: 'directus',
                                            name: resFile.data.data.title,
                                            file: data.data.cover.file
                                        }
                                    ];
                                    await asyncForEach(complete_cover, async (complete_gallery_item, complete_gallery_index) => {
                                        console.log('posting rezising file :D');
                                        if (complete_gallery_item.origin != 'directus') {
                                            await directusApi('POST', `files`, complete_gallery_item.file)
                                                .then(async (resFile: any) => {
                                                    if (data.data.cover.hasOwnProperty('alt')) {
                                                        await directusApi('PATCH', `files/${resFile.data.data.id}`, { alt: data.data.cover.alt })
                                                            .then(async (resFile: any) => {
                                                                console.log('Alt added to complete gallery');
                                                            })
                                                            .catch(err => {
                                                                console.log(err);
                                                            });
                                                    }
                                                    complete_cover[complete_gallery_index] = { id: resFile.data.data.id, sort: null, name: resFile.data.data.title, origin: 'directus', alt: data.data.cover.hasOwnProperty('alt') ? data.data.cover.alt : '' };
                                                })
                                                .catch(err => {
                                                    console.log(err);
                                                });
                                        }
                                    });
                                })
                                .catch(err => {
                                    console.log(err);
                                });
                            // await directusApi('POST', `files`, data.data.cover.file)
                            //     .then(async (resFile: any) => {
                            //         cover = { id: resFile.data.data.id };
                            //     })
                            //     .catch(err => {
                            //         console.log(err);
                            //     });
                        } else {
                            data.vm.$bvToast.toast(`Error al guardar, la imagen ${data.data.cover.name} ya existe.`, {
                                title: `Imagen ya existente`,
                                variant: 'warning',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                            commit('TOGGLE_ACTIVE_PRODUCT_CATEGORY_LOADING', false);
                            return false;
                        }
                    } else if (data.data.cover.origin == 'directus-update') {
                        await directusApi('GET', `files/${data.data.cover.id}`)
                            .then(async (resFile: any) => {
                                cover = resFile.data.data;
                            })
                            .catch(err => {
                                console.log(err);
                            });
                    } else {
                        if (data.data.cover) {
                            await directusApi('GET', `files/${data.data.cover.id}`)
                                .then(async (resFile: any) => {
                                    cover = resFile.data.data;
                                })
                                .catch(err => {
                                    console.log(err);
                                });
                        }
                    }
                } catch (error) {
                    console.log('error => no contiene un cover');
                }

                // ******** START updating alt field in image attribute
                if (data.data.image && data.data.image.hasOwnProperty('alt') && data.data.image.origin != 'upload') {
                    await directusApi('PATCH', `files/${data.data.image.id}`, { alt: data.data.image.alt })
                        .then(async (resFile: any) => {
                            if (complete_image) {
                                await asyncForEach(complete_image, async (complete_gallery_item, complete_gallery_index) => {
                                    await directusApi('PATCH', `files/${complete_gallery_item.id}`, { alt: data.data.image.alt })
                                        .then(async (resFile: any) => {
                                            complete_image[complete_gallery_index] =
                                            {
                                                ...complete_image[complete_gallery_index],
                                                alt: data.data.image.alt
                                            }
                                        })
                                        .catch(err => {
                                            console.log(err);
                                        });
                                });
                                console.log('Alt updated in all gallery');

                            }
                            console.log('Alt updated succesfully');

                        })
                        .catch(err => {
                            console.log(err);
                        });
                }
                // ******** END updating alt field in image attribute

                // ********************** START adding id of image to category
                if (image) {
                    if (image.length > 0) {
                        image[0].hasOwnProperty('id') ? image[0] = image[0].id : image;
                    }
                    await directusApi('PATCH', `items/products_categories/${category.data.data.id}`, { image: image[0], complete_image: complete_image })
                        .then(async (res: any) => {
                            console.log('image added/updated', res.data.data.image);
                            dispatch('getOne', category.data.data.id);
                            data.vm.$bvToast.toast('Información agregada/actualizada exitosamente', {
                                title: `Obteniendo información`,
                                variant: 'success',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                        })
                        .catch(err => {
                            console.log(err);
                        });
                } else {
                    await directusApi('PATCH', `items/products_categories/${category.data.data.id}`, { image: null, complete_image: '[]' })
                        .then(async (res: any) => {
                            console.log('image removed');
                            dispatch('getOne', category.data.data.id);
                            data.vm.$bvToast.toast('Información agregada/actualizada exitosamente', {
                                title: `Obteniendo información`,
                                variant: 'success',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                        })
                        .catch(err => {
                            console.log(err);
                        });
                }
                // ********************** END adding id of image to category

                // await directusApi('PATCH', `items/products_categories/${category.data.data.id}`, { image })
                //     .then(async (res: any) => {
                //         console.log('image added/updated', res.data.data.image);
                //     })
                //     .catch(err => {
                //         console.log(err);
                //     });

                // ******** START updating alt field in cover attribute
                if (data.data.cover && data.data.cover.hasOwnProperty('alt') && data.data.cover.origin != 'upload') {
                    await directusApi('PATCH', `files/${data.data.cover.id}`, { alt: data.data.cover.alt })
                        .then(async (resFile: any) => {
                            if (complete_cover) {
                                await asyncForEach(complete_cover, async (complete_gallery_item, complete_gallery_index) => {
                                    await directusApi('PATCH', `files/${complete_gallery_item.id}`, { alt: data.data.cover.alt })
                                        .then(async (resFile: any) => {
                                            complete_cover[complete_gallery_index] =
                                            {
                                                ...complete_cover[complete_gallery_index],
                                                alt: data.data.cover.alt
                                            }
                                        })
                                        .catch(err => {
                                            console.log(err);
                                        });
                                });
                                console.log('Alt updated in all gallery');

                            }
                            console.log('Alt updated succesfully');

                        })
                        .catch(err => {
                            console.log(err);
                        });
                }
                // ******** END updating alt field in cover attribute

                // ********************** START adding id of cover to category
                if (cover) {
                    if (cover.length > 0) {
                        cover[0].hasOwnProperty('id') ? cover[0] = cover[0].id : cover;
                    }
                    await directusApi('PATCH', `items/products_categories/${category.data.data.id}`, { cover: cover[0], complete_cover: complete_cover })
                        .then(async (res: any) => {
                            console.log('cover added/updated', res.data.data.cover);
                            dispatch('getOne', category.data.data.id);
                            data.vm.$bvToast.toast('Información agregada/actualizada exitosamente', {
                                title: `Obteniendo información`,
                                variant: 'success',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                        })
                        .catch(err => {
                            console.log(err);
                        });
                } else {
                    await directusApi('PATCH', `items/products_categories/${category.data.data.id}`, { cover: null, complete_cover: '[]' })
                        .then(async (res: any) => {
                            console.log('cover removed');
                            dispatch('getOne', category.data.data.id);
                            data.vm.$bvToast.toast('Información agregada/actualizada exitosamente', {
                                title: `Obteniendo información`,
                                variant: 'success',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                        })
                        .catch(err => {
                            console.log(err);
                        });
                }
                // ********************** END adding id of cover to category
                commit('TOGGLE_ACTIVE_PRODUCT_CATEGORY_LOADING', false);
                dispatch("getAll");
                commit('SET_ACTIVE_PRODUCT_CATEGORY', category.data.data);
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_ACTIVE_PRODUCT_CATEGORY_LOADING', false);
            });
    },
    async deleteOne({ _, commit, dispatch }: any, data: any) {
        await directusApi('DELETE', `items/products_categories/${data.id}`, {})
            .then(async (res: any) => {
                data.vm.$bvToast.toast('Se ha eliminado exitosamente', {
                    title: `Categoría eliminada`,
                    variant: 'success',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                });
                commit('REMOVE_PRODUCT_CATEGORY', data.id);
                dispatch('getAll');
            })
            .catch(err => {
                console.log(err);
            });
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
